"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBadRequestResponseDto = instanceOfBadRequestResponseDto;
exports.BadRequestResponseDtoFromJSON = BadRequestResponseDtoFromJSON;
exports.BadRequestResponseDtoFromJSONTyped = BadRequestResponseDtoFromJSONTyped;
exports.BadRequestResponseDtoToJSON = BadRequestResponseDtoToJSON;
exports.BadRequestResponseDtoToJSONTyped = BadRequestResponseDtoToJSONTyped;
/**
 * Check if a given object implements the BadRequestResponseDto interface.
 */
function instanceOfBadRequestResponseDto(value) {
    if (!('error' in value) || value['error'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    if (!('statusCode' in value) || value['statusCode'] === undefined)
        return false;
    if (!('reasons' in value) || value['reasons'] === undefined)
        return false;
    return true;
}
function BadRequestResponseDtoFromJSON(json) {
    return BadRequestResponseDtoFromJSONTyped(json, false);
}
function BadRequestResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'error': json['error'],
        'message': json['message'],
        'statusCode': json['statusCode'],
        'reasons': json['reasons'],
    };
}
function BadRequestResponseDtoToJSON(json) {
    return BadRequestResponseDtoToJSONTyped(json, false);
}
function BadRequestResponseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'error': value['error'],
        'message': value['message'],
        'statusCode': value['statusCode'],
        'reasons': value['reasons'],
    };
}
//# sourceMappingURL=BadRequestResponseDto.js.map